<template>
  <!-- 跟进异常 -->
  <div class="pagesBox">
    <div style="height: 60px; width: 100%"></div>
    <div class="topBtns">
      <el-button
        style="margin-top: 10px"
        class="glo_bgcMainColor"
        @click="submit"
      >保存</el-button>
    </div>
    <div class="formbox">
      <el-form
        :model="baseInForm"
        :rules="rules"
        ref="baseInFormRef"
        label-width="130px"
        class="glo_formBox"
      >
        <el-form-item
          label="异常编号:"
          prop="number"
        >
          <el-input
            v-model="number"
            placeholder="自动带出"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          label="处理人:"
          prop="handleUserId"
          style="width: 320px"
        >
          <el-select
            filterable
            v-model="baseInForm.handleUserId"
            placeholder="请选择"
            @change="changeUser"
          >
            <el-option
              v-for="item in employeeList"
              :key="item.documentId"
              :label="item.name"
              :value="item.documentId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="处理时间:"
          prop="handleTime"
          style="width: 320px"
        >
          <el-date-picker
            v-model="baseInForm.handleTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>

        <el-form-item
          class="textArea"
          style="width: 100%"
          label="处理描述:"
          prop="handleDescribe"
        >
          <el-input
            type="textarea"
            rows="3"
            placeholder="请输入"
            v-model="baseInForm.handleDescribe"
          ></el-input>
        </el-form-item>

        <!-- <el-form-item
          class="textArea"
          style="width: 100%"
          label="处理描述:"
          prop=""
        >
          <div id="eidtContent_zh-CN"></div>
        </el-form-item>-->

        <!-- <el-form-item label="创建人:" prop="aaa" style="width: 320px">
          <el-input
            v-model="baseInForm.aaa"
            placeholder="请输入"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="创建时间:" prop="aaa" style="width: 320px">
          <el-date-picker
            v-model="baseInForm.aaa"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
            disabled
          >
          </el-date-picker>
        </el-form-item>-->

        <div class="uploadBox">
          <div class="uploadItem">
            <div class="uploadLaber">异常图片</div>
            <uploadimgs
              @input="changeFileList"
              :fileNameLists="fileNameLists"
              :limit="9"
            ></uploadimgs>
          </div>
        </div>
      </el-form>
    </div>

    <div
      class="glo_Table"
      style="margin-bottom: 20px"
    >
      <div class="h3title">跟进记录</div>
      <el-table
        :data="tableData2"
        border
        style="width: 100%"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="handleUserName"
          label="处理人"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="handleTime"
          label="处理时间"
        ></el-table-column>
        <el-table-column
          align="center"
          prop
          label="查看图片"
        >
          <template slot-scope="scope">
            <div
              class="lookImgsDIV"
              @click="looksimgs(scope.row)"
            >查看图片</div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="handleDescribe"
          label="处理描述"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="number"
          label="原运单号"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="createTime"
          label="创建时间"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="createUserName"
          label="创建人"
        ></el-table-column>
      </el-table>
    </div>

    <bigimgs
      :bigImgsShow="bigImgsShow"
      :srcList="srcList"
      @closeDialog="closeDialog"
    ></bigimgs>
  </div>
</template>
<script>
import uploadimgs from '@/components/upLoadImgs.vue'
import bigimgs from '@/components/lookBigImgs.vue'
// import E from "wangeditor";
export default {
  components: { uploadimgs, bigimgs },
  data() {
    return {
      bigImgsShow: false,
      srcList: [],
      baseInForm: {
        handleUserName: '',
        handleUserId: '',
        handleTime: '',
        handleDescribe: '',
        fileIds: [],
      },
      number: '',
      contents: {
        content: '',
        title: '',
        editor: {},
      },
      fileNameLists: [],
      fileNameLists2: [],

      rules: {
        handleTime: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] },
        ],
        handleUserId: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] },
        ],
      },
      CustomerList: [],
      tableData2: [],

      employeeList: [],
    }
  },
  watch: {},
  created() {},
  mounted() {
    // this.$nextTick(() => {
    //   this.initLangeuage();
    // });
    this.getObjectUserDownLists('employee')
  },
  activated() {
    let exceptionId = this.$route.query.exceptionId || ''
    let number = this.$route.query.number || ''
    this.tableData2 = []
    this.fileNameLists = []
    this.baseInForm = {
      handleUserName: '',
      handleUserId: '',
      handleTime: '',
      handleDescribe: '',
      fileIds: [],
    }
    if (exceptionId) {
      this.exceptionId = exceptionId
      this.number = number
      this.getData1() // 获取异常详情-跟进记录
      // this.getDetails(); //获取详情

      // this.$API
      //   .getExceptionDutyDetail({ exceptionId: exceptionId })
      //   .then((res) => {
      //     console.log(res, "res");
      //     this.baseInForm = res.data.result;
      //   });
    }
  },
  destroyed() {},
  methods: {
    looksimgs(row) {
      console.log(row)
      let fildList = row.fileIds || []
      if (fildList.length > 0) {
        let ids = fildList.map((item) => {
          return item
        })
        this.$API.getFileUrlMore({ fileNames: ids }).then((res) => {
          console.log('res', res)
          let srcLists = res.data.result || []
          let arr1 = srcLists.map((imtes) => {
            return imtes.url
          })
          this.srcList = arr1
          this.bigImgsShow = true
        })
      } else {
        this.$message.error('没有图片哦')
      }

      //
    },
    closeDialog(e) {
      this.bigImgsShow = false
    },

    getObjectUserDownLists(key) {
      this.$COMAPI.getObjectUserDownList(key).then((res) => {
        if (key == 'employee') {
          // 获取员工列表
          this.employeeList = res || []
        }
      })
      // this.$COMAPI.getObjectUserDownList("employee").then(res=>{}); //获取员工列表
      // this.$COMAPI.getObjectUserDownList("dept").then(res=>{}); //获取部门列表
      // this.$COMAPI.getObjectUserDownList("storage").then(res=>{}); //获取网点列表
    },
    changeUser(e) {
      if (e) {
        this.employeeList.forEach((item) => {
          if (item.documentId == e) {
            this.baseInForm.handleUserName = item.name
          }
        })
      } else {
        this.getCarrierList()
        this.baseInForm.handleUserName = ''
      }
    },
    // 跟进
    submit() {
      let ids = this.fileNameLists.map((item) => {
        return item.name
      })
      // let describe = this.contents.editor.txt.html();
      let param = {
        exceptionId: this.exceptionId,
        handleDescribe: this.baseInForm.handleDescribe,
        handleTime: this.baseInForm.handleTime,
        handleUserId: this.baseInForm.handleUserId,
        handleUserName: this.baseInForm.handleUserName,
        fileIds: ids || [],
      }
      this.$API.wtl_handelException(param).then((res) => {
        this.$message.success(res.data.message || '操作成功')
        this.getData1()
      })
    },
    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array
    },
    // 选择图片
    changeFileList2(array) {
      this.fileNameLists = array
    },
    getDetails() {
      this.$API
        .wtl_getExceptionDetail({ exceptionId: this.exceptionId })
        .then((res) => {})
    },
    // 获取异常详情-跟进记录
    getData1() {
      this.$API
        .wtl_getExceptionHandelRecord({ exceptionId: this.exceptionId })
        .then((res) => {
          this.tableData2 = res.data.result || []
        })
    },

    initLangeuage() {
      this.contents.editor = {}
      this.contents.editor = new E('#eidtContent_zh-CN')
      this.contents.editor.config.height = 200 //富文本高度
      // 编辑器菜单栏配置
      this.contents.editor.config.menus = [
        'head', // 标题
        'bold', // 粗体
        'fontSize', // 字号
        'indent', //缩进
        'fontName', // 字体
        'italic', // 斜体
        'underline', // 下划线
        'strikeThrough', // 删除线
        'foreColor', // 文字颜色
        'backColor', // 背景颜色
        'link', // 插入链接
        'list', // 列表
        'justify', // 对齐方式
        'quote', // 引用
        'emoticon', // 表情
        'table', // 表格
        'code', // 插入代码
        'undo', // 撤销
        'redo', // 重复
      ]
      this.contents.editor.create()
    },
  },
}
</script>
<style scoped lang='less'>
// 查询条件边框线
@borderColor: #cccccc;
.topBtns {
  width: calc(100% - 270px);
  position: fixed;
  z-index: 10;
  top: 60px;
  left: 210px;
  background-color: #fff;
  // box-shadow: 2px 2px 5px #ccc;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
}

.formbox {
  padding: 10px 30px 30px;

  .jsInput {
    .jsBtns {
      height: 30px;
      line-height: 30px;
      margin: 0;
      padding: 0 10px;
      border: none;
    }
  }

  .formBtns {
    height: 30px;
    margin: 0;
    padding: 0 10px;
  }

  .checkBoxStyle {
    width: 23%;
    min-width: 260px;
    margin-bottom: 10px;

    display: flex;
    align-items: center;
  }
}

.uploadBox {
  width: 100%;
  display: flex;
  align-items: center;

  .uploadItem {
    flex: 1;

    .uploadLaber {
      margin-bottom: 10px;
    }
  }
}

.topBtns {
  margin: 0 30px;
  height: 50px;
}

.twoInput {
  display: flex;
}
.h3title {
  background-color: #f2f2f2;
  padding: 10px;
  border-bottom: 1px solid @borderColor;
  font-weight: bold;
  margin-bottom: 10px;
}

.textArea {
  height: auto !important;
}
.glo_formBox .textArea {
  /deep/ .el-form-item__content {
    height: auto !important;
    z-index: 0;
  }
}

.lookImgsDIV {
  color: blue;
  cursor: pointer;
}
</style>